
import Vue from 'vue'
import axios from 'axios'
import { Component } from 'vue-property-decorator'
import { ChartConfiguration } from 'chart.js'
import { getColors } from '../../global/utils'
import AppChart from '../../global/components/AppChart.vue'

type JobStatInfo = {
  title: string;
  total: number;
  data: { name: string; count: number; }[]
}

@Component
export default class JobChart extends Vue {
  private get chart() {
    return this.$refs.chart as AppChart<'bar', number>
  }

  mounted() {
    this.getCompletedJobsStatsData()
  }

  async getCompletedJobsStatsData() {
    const response = await axios.get<JobStatInfo>('/stats/completed-jobs')
    const config = this.formatJobChartConfig(response.data)
    this.chart.loadConfig(config)
    this.$emit('total', response.data.total)
  }

  private formatJobChartConfig(chartInfo: JobStatInfo): ChartConfiguration<'bar', number[], string> {
    const categoryWidth = this.$vuetify.breakpoint.mdAndUp ? 0.4 : 0.8
    return {
      type: 'bar',
      data: {
        labels: chartInfo.data.map(i => i.name) || [],
        datasets: [{
          data: chartInfo.data.map(i => i.count) || [],
          backgroundColor: getColors(chartInfo.data.length || 0),
          categoryPercentage: categoryWidth
        }]
      },
      options: {
        scales: {
          y: { beginAtZero: true }
        },
        plugins: {
          legend: {
            display: false
          },
          title: {
            display: true,
            text: chartInfo.title
          },
          tooltip: {
            position: 'nearest'
          }
        }
      }
    }
  }
}
